module.exports = __webpack_public_path__ + "img/bg-pattern@3x.8908b915.png";